import React from "react"; // Make sure to import React if you haven't already
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table"; // Import necessary hooks

import { Table, Tbody, Th, Thead, Tr, Input, Td } from "@chakra-ui/react";

const LlmBigqueryTableUIChat = ({ llm_table_data }) => {
  const columns = React.useMemo(
    () =>
      Object.keys(llm_table_data[0]).map((name) => ({
        Header: name,
        accessor: name,
        width: 10, // Set the width to 50px for each column
      })),
    [llm_table_data]
  );

  const data = React.useMemo(() => llm_table_data, [llm_table_data]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useGlobalFilter,
      useSortBy,
      usePagination
    );

  return (
    <div className="w-full h-[90%] px-5 relative overflow-x-auto shadow-md sm:rounded-lg">
      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="px-6 py-3 w-4/5 relative"
                >
                  <div className="whitespace-nowrap overflow-hidden text-ellipsis ">
                    {column.render("Header")}
                    <span className="ml-2">
                      {column.isSorted
                        ? column.isSortedDesc
                          ? "🔽"
                          : "🔼"
                        : "⏹️"}
                    </span>
                  </div>
                  <div
                    className={`resizer ${
                      column.isResizing ? "isResizing" : ""
                    }`}
                  />
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps()}
                  className="px-6 py-3 w-4/5 relative"
                >
                  {column.canFilter ? column.render("Filter") : null}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className="bg-color-text-2 border-color-text border-opacity-30 border-b"
        >
          {rows.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <Td {...cell.getCellProps()} className="px-6 py-4 w-4/5">
                    <div className="whitespace-nowrap overflow-hidden text-ellipsis ">
                      {cell.render("Cell")}
                    </div>
                  </Td>
                ))}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </div>
  );
};

export default LlmBigqueryTableUIChat;
